import React from 'react'

import { translate } from '~/core/translate'
import { Creator, Question } from './styled'

const PollHeading = ({ creator, question }) => (
  <>
    <Question>{question}</Question>
    <Creator>{translate('by', { name: creator })}</Creator>
  </>
)

export default PollHeading
